// @generated by protoc-gen-connect-query v1.3.1 with parameter "target=ts"
// @generated from file ssoready/v1/ssoready.proto (package ssoready.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Empty, MethodKind } from "@bufbuild/protobuf";
import { AdminCreateSAMLConnectionRequest, AdminCreateSAMLConnectionResponse, AdminCreateSCIMDirectoryRequest, AdminCreateSCIMDirectoryResponse, AdminGetSAMLConnectionRequest, AdminGetSAMLConnectionResponse, AdminGetSAMLFlowRequest, AdminGetSAMLFlowResponse, AdminGetSCIMDirectoryRequest, AdminGetSCIMDirectoryResponse, AdminListSAMLConnectionsRequest, AdminListSAMLConnectionsResponse, AdminListSAMLFlowsRequest, AdminListSAMLFlowsResponse, AdminListSCIMDirectoriesRequest, AdminListSCIMDirectoriesResponse, AdminParseSAMLMetadataRequest, AdminParseSAMLMetadataResponse, AdminRedeemOneTimeTokenRequest, AdminRedeemOneTimeTokenResponse, AdminRotateSCIMDirectoryBearerTokenRequest, AdminRotateSCIMDirectoryBearerTokenResponse, AdminUpdateSAMLConnectionRequest, AdminUpdateSAMLConnectionResponse, AdminUpdateSCIMDirectoryRequest, AdminUpdateSCIMDirectoryResponse, AdminWhoamiRequest, AdminWhoamiResponse, APIKey, AppCreateAdminSetupURLRequest, AppCreateAdminSetupURLResponse, AppCreateOrganizationRequest, AppCreateSAMLConnectionRequest, AppCreateSCIMDirectoryRequest, AppGetAdminSettingsRequest, AppGetAdminSettingsResponse, AppGetOrganizationRequest, AppGetSAMLConnectionRequest, AppGetSAMLFlowRequest, AppGetSCIMDirectoryRequest, AppGetSCIMGroupRequest, AppGetSCIMRequestRequest, AppGetSCIMRequestResponse, AppGetSCIMUserRequest, AppListOrganizationsRequest, AppListOrganizationsResponse, AppListSAMLConnectionsRequest, AppListSAMLConnectionsResponse, AppListSAMLFlowsRequest, AppListSAMLFlowsResponse, AppListSCIMDirectoriesRequest, AppListSCIMDirectoriesResponse, AppListSCIMGroupsRequest, AppListSCIMGroupsResponse, AppListSCIMRequestsRequest, AppListSCIMRequestsResponse, AppListSCIMUsersRequest, AppListSCIMUsersResponse, AppRotateSCIMDirectoryBearerTokenRequest, AppRotateSCIMDirectoryBearerTokenResponse, AppUpdateAdminSettingsLogoRequest, AppUpdateAdminSettingsLogoResponse, AppUpdateAdminSettingsRequest, AppUpdateAdminSettingsResponse, AppUpdateOrganizationRequest, AppUpdateSAMLConnectionRequest, AppUpdateSCIMDirectoryRequest, CheckEnvironmentCustomDomainSettingsCertificatesRequest, CheckEnvironmentCustomDomainSettingsCertificatesResponse, CreateAPIKeyRequest, CreateEnvironmentRequest, CreateOrganizationRequest, CreateOrganizationResponse, CreateSAMLConnectionRequest, CreateSAMLConnectionResponse, CreateSAMLOAuthClientRequest, CreateSCIMDirectoryRequest, CreateSCIMDirectoryResponse, CreateSetupURLRequest, CreateSetupURLResponse, DeleteAPIKeyRequest, DeleteSAMLOAuthClientRequest, Environment, GetAPIKeyRequest, GetAppOrganizationRequest, GetAppOrganizationResponse, GetEnvironmentCustomDomainSettingsRequest, GetEnvironmentCustomDomainSettingsResponse, GetEnvironmentRequest, GetOnboardingStateRequest, GetOnboardingStateResponse, GetOrganizationRequest, GetOrganizationResponse, GetSAMLConnectionRequest, GetSAMLConnectionResponse, GetSAMLOAuthClientRequest, GetSAMLRedirectURLRequest, GetSAMLRedirectURLResponse, GetSCIMDirectoryRequest, GetSCIMDirectoryResponse, GetSCIMGroupRequest, GetSCIMGroupResponse, GetSCIMUserRequest, GetSCIMUserResponse, ListAPIKeysRequest, ListAPIKeysResponse, ListAppUsersRequest, ListAppUsersResponse, ListEnvironmentsRequest, ListEnvironmentsResponse, ListOrganizationsRequest, ListOrganizationsResponse, ListSAMLConnectionsRequest, ListSAMLConnectionsResponse, ListSAMLOAuthClientsRequest, ListSAMLOAuthClientsResponse, ListSCIMDirectoriesRequest, ListSCIMDirectoriesResponse, ListSCIMGroupsRequest, ListSCIMGroupsResponse, ListSCIMUsersRequest, ListSCIMUsersResponse, OnboardingGetSAMLRedirectURLRequest, OnboardingRedeemSAMLAccessCodeRequest, Organization, ParseSAMLMetadataRequest, ParseSAMLMetadataResponse, RedeemSAMLAccessCodeRequest, RedeemSAMLAccessCodeResponse, RotateSCIMDirectoryBearerTokenRequest, RotateSCIMDirectoryBearerTokenResponse, SAMLConnection, SAMLFlow, SAMLOAuthClient, SCIMDirectory, SCIMGroup, SCIMUser, SignInRequest, SignInResponse, SignOutRequest, SignOutResponse, UpdateEnvironmentCustomDomainSettingsRequest, UpdateEnvironmentCustomDomainSettingsResponse, UpdateEnvironmentRequest, UpdateOnboardingStateRequest, UpdateOrganizationRequest, UpdateOrganizationResponse, UpdateSAMLConnectionRequest, UpdateSAMLConnectionResponse, UpdateSCIMDirectoryRequest, UpdateSCIMDirectoryResponse, VerifyEmailRequest, WhoamiRequest, WhoamiResponse } from "./ssoready_pb.js";

/**
 * Gets a SAML initiation URL to redirect your users to.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.GetSAMLRedirectURL
 */
export const getSAMLRedirectURL = {
  localName: "getSAMLRedirectURL",
  name: "GetSAMLRedirectURL",
  kind: MethodKind.Unary,
  I: GetSAMLRedirectURLRequest,
  O: GetSAMLRedirectURLResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Exchanges a SAML access code for details about your user's SAML login details.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.RedeemSAMLAccessCode
 */
export const redeemSAMLAccessCode = {
  localName: "redeemSAMLAccessCode",
  name: "RedeemSAMLAccessCode",
  kind: MethodKind.Unary,
  I: RedeemSAMLAccessCodeRequest,
  O: RedeemSAMLAccessCodeResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Gets a list of SCIM users in a SCIM directory.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.ListSCIMUsers
 */
export const listSCIMUsers = {
  localName: "listSCIMUsers",
  name: "ListSCIMUsers",
  kind: MethodKind.Unary,
  I: ListSCIMUsersRequest,
  O: ListSCIMUsersResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Gets a SCIM user.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.GetSCIMUser
 */
export const getSCIMUser = {
  localName: "getSCIMUser",
  name: "GetSCIMUser",
  kind: MethodKind.Unary,
  I: GetSCIMUserRequest,
  O: GetSCIMUserResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Gets a list of SCIM groups in a SCIM directory.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.ListSCIMGroups
 */
export const listSCIMGroups = {
  localName: "listSCIMGroups",
  name: "ListSCIMGroups",
  kind: MethodKind.Unary,
  I: ListSCIMGroupsRequest,
  O: ListSCIMGroupsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Gets a SCIM group in a SCIM directory.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.GetSCIMGroup
 */
export const getSCIMGroup = {
  localName: "getSCIMGroup",
  name: "GetSCIMGroup",
  kind: MethodKind.Unary,
  I: GetSCIMGroupRequest,
  O: GetSCIMGroupResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Gets a list of organizations.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.ListOrganizations
 */
export const listOrganizations = {
  localName: "listOrganizations",
  name: "ListOrganizations",
  kind: MethodKind.Unary,
  I: ListOrganizationsRequest,
  O: ListOrganizationsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Gets an organization.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.GetOrganization
 */
export const getOrganization = {
  localName: "getOrganization",
  name: "GetOrganization",
  kind: MethodKind.Unary,
  I: GetOrganizationRequest,
  O: GetOrganizationResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Creates an organization.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.CreateOrganization
 */
export const createOrganization = {
  localName: "createOrganization",
  name: "CreateOrganization",
  kind: MethodKind.Unary,
  I: CreateOrganizationRequest,
  O: CreateOrganizationResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Updates an organization.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.UpdateOrganization
 */
export const updateOrganization = {
  localName: "updateOrganization",
  name: "UpdateOrganization",
  kind: MethodKind.Unary,
  I: UpdateOrganizationRequest,
  O: UpdateOrganizationResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Creates a short-lived self-serve setup URL that you can send to your customer.
 *
 * Setup URLs let your customer configure their SAML settings, SCIM settings, or both.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.CreateSetupURL
 */
export const createSetupURL = {
  localName: "createSetupURL",
  name: "CreateSetupURL",
  kind: MethodKind.Unary,
  I: CreateSetupURLRequest,
  O: CreateSetupURLResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Lists SAML connections in an organization.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.ListSAMLConnections
 */
export const listSAMLConnections = {
  localName: "listSAMLConnections",
  name: "ListSAMLConnections",
  kind: MethodKind.Unary,
  I: ListSAMLConnectionsRequest,
  O: ListSAMLConnectionsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Gets a SAML connection.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.GetSAMLConnection
 */
export const getSAMLConnection = {
  localName: "getSAMLConnection",
  name: "GetSAMLConnection",
  kind: MethodKind.Unary,
  I: GetSAMLConnectionRequest,
  O: GetSAMLConnectionResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Creates a SAML connection.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.CreateSAMLConnection
 */
export const createSAMLConnection = {
  localName: "createSAMLConnection",
  name: "CreateSAMLConnection",
  kind: MethodKind.Unary,
  I: CreateSAMLConnectionRequest,
  O: CreateSAMLConnectionResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Updates a SAML connection.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.UpdateSAMLConnection
 */
export const updateSAMLConnection = {
  localName: "updateSAMLConnection",
  name: "UpdateSAMLConnection",
  kind: MethodKind.Unary,
  I: UpdateSAMLConnectionRequest,
  O: UpdateSAMLConnectionResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Gets a list of SCIM directories in an organization.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.ListSCIMDirectories
 */
export const listSCIMDirectories = {
  localName: "listSCIMDirectories",
  name: "ListSCIMDirectories",
  kind: MethodKind.Unary,
  I: ListSCIMDirectoriesRequest,
  O: ListSCIMDirectoriesResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Gets a SCIM directory.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.GetSCIMDirectory
 */
export const getSCIMDirectory = {
  localName: "getSCIMDirectory",
  name: "GetSCIMDirectory",
  kind: MethodKind.Unary,
  I: GetSCIMDirectoryRequest,
  O: GetSCIMDirectoryResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Creates a SCIM directory.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.CreateSCIMDirectory
 */
export const createSCIMDirectory = {
  localName: "createSCIMDirectory",
  name: "CreateSCIMDirectory",
  kind: MethodKind.Unary,
  I: CreateSCIMDirectoryRequest,
  O: CreateSCIMDirectoryResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Updates a SCIM directory.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.UpdateSCIMDirectory
 */
export const updateSCIMDirectory = {
  localName: "updateSCIMDirectory",
  name: "UpdateSCIMDirectory",
  kind: MethodKind.Unary,
  I: UpdateSCIMDirectoryRequest,
  O: UpdateSCIMDirectoryResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * Rotates a SCIM directory's bearer token.
 *
 * Every SCIM directory has a bearer token that SSOReady uses to authenticate requests sent from your customer's
 * Identity Provider. These bearer tokens are assigned by SSOReady, and are secret. Newly-created SCIM directories do
 * not have any bearer token at all; you must use this endpoint to get an initial value.
 *
 * Rotating a SCIM directory bearer token immediately invalidates the previous bearer token, if any. Your customer
 * will need to update their SCIM configuration with the new value to make SCIM syncing work again.
 *
 * SSOReady only stores the hash of these bearer tokens. If your customer has lost their copy, you must use this
 * endpoint to generate a new one.
 *
 * @generated from rpc ssoready.v1.SSOReadyService.RotateSCIMDirectoryBearerToken
 */
export const rotateSCIMDirectoryBearerToken = {
  localName: "rotateSCIMDirectoryBearerToken",
  name: "RotateSCIMDirectoryBearerToken",
  kind: MethodKind.Unary,
  I: RotateSCIMDirectoryBearerTokenRequest,
  O: RotateSCIMDirectoryBearerTokenResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.VerifyEmail
 */
export const verifyEmail = {
  localName: "verifyEmail",
  name: "VerifyEmail",
  kind: MethodKind.Unary,
  I: VerifyEmailRequest,
  O: Empty,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.SignIn
 */
export const signIn = {
  localName: "signIn",
  name: "SignIn",
  kind: MethodKind.Unary,
  I: SignInRequest,
  O: SignInResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.SignOut
 */
export const signOut = {
  localName: "signOut",
  name: "SignOut",
  kind: MethodKind.Unary,
  I: SignOutRequest,
  O: SignOutResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.Whoami
 */
export const whoami = {
  localName: "whoami",
  name: "Whoami",
  kind: MethodKind.Unary,
  I: WhoamiRequest,
  O: WhoamiResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.GetOnboardingState
 */
export const getOnboardingState = {
  localName: "getOnboardingState",
  name: "GetOnboardingState",
  kind: MethodKind.Unary,
  I: GetOnboardingStateRequest,
  O: GetOnboardingStateResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.UpdateOnboardingState
 */
export const updateOnboardingState = {
  localName: "updateOnboardingState",
  name: "UpdateOnboardingState",
  kind: MethodKind.Unary,
  I: UpdateOnboardingStateRequest,
  O: Empty,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.OnboardingGetSAMLRedirectURL
 */
export const onboardingGetSAMLRedirectURL = {
  localName: "onboardingGetSAMLRedirectURL",
  name: "OnboardingGetSAMLRedirectURL",
  kind: MethodKind.Unary,
  I: OnboardingGetSAMLRedirectURLRequest,
  O: GetSAMLRedirectURLResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.OnboardingRedeemSAMLAccessCode
 */
export const onboardingRedeemSAMLAccessCode = {
  localName: "onboardingRedeemSAMLAccessCode",
  name: "OnboardingRedeemSAMLAccessCode",
  kind: MethodKind.Unary,
  I: OnboardingRedeemSAMLAccessCodeRequest,
  O: RedeemSAMLAccessCodeResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.GetAppOrganization
 */
export const getAppOrganization = {
  localName: "getAppOrganization",
  name: "GetAppOrganization",
  kind: MethodKind.Unary,
  I: GetAppOrganizationRequest,
  O: GetAppOrganizationResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.ListAppUsers
 */
export const listAppUsers = {
  localName: "listAppUsers",
  name: "ListAppUsers",
  kind: MethodKind.Unary,
  I: ListAppUsersRequest,
  O: ListAppUsersResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.ListEnvironments
 */
export const listEnvironments = {
  localName: "listEnvironments",
  name: "ListEnvironments",
  kind: MethodKind.Unary,
  I: ListEnvironmentsRequest,
  O: ListEnvironmentsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.GetEnvironment
 */
export const getEnvironment = {
  localName: "getEnvironment",
  name: "GetEnvironment",
  kind: MethodKind.Unary,
  I: GetEnvironmentRequest,
  O: Environment,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.CreateEnvironment
 */
export const createEnvironment = {
  localName: "createEnvironment",
  name: "CreateEnvironment",
  kind: MethodKind.Unary,
  I: CreateEnvironmentRequest,
  O: Environment,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.UpdateEnvironment
 */
export const updateEnvironment = {
  localName: "updateEnvironment",
  name: "UpdateEnvironment",
  kind: MethodKind.Unary,
  I: UpdateEnvironmentRequest,
  O: Environment,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.GetEnvironmentCustomDomainSettings
 */
export const getEnvironmentCustomDomainSettings = {
  localName: "getEnvironmentCustomDomainSettings",
  name: "GetEnvironmentCustomDomainSettings",
  kind: MethodKind.Unary,
  I: GetEnvironmentCustomDomainSettingsRequest,
  O: GetEnvironmentCustomDomainSettingsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.UpdateEnvironmentCustomDomainSettings
 */
export const updateEnvironmentCustomDomainSettings = {
  localName: "updateEnvironmentCustomDomainSettings",
  name: "UpdateEnvironmentCustomDomainSettings",
  kind: MethodKind.Unary,
  I: UpdateEnvironmentCustomDomainSettingsRequest,
  O: UpdateEnvironmentCustomDomainSettingsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.CheckEnvironmentCustomDomainSettingsCertificates
 */
export const checkEnvironmentCustomDomainSettingsCertificates = {
  localName: "checkEnvironmentCustomDomainSettingsCertificates",
  name: "CheckEnvironmentCustomDomainSettingsCertificates",
  kind: MethodKind.Unary,
  I: CheckEnvironmentCustomDomainSettingsCertificatesRequest,
  O: CheckEnvironmentCustomDomainSettingsCertificatesResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.ListAPIKeys
 */
export const listAPIKeys = {
  localName: "listAPIKeys",
  name: "ListAPIKeys",
  kind: MethodKind.Unary,
  I: ListAPIKeysRequest,
  O: ListAPIKeysResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.GetAPIKey
 */
export const getAPIKey = {
  localName: "getAPIKey",
  name: "GetAPIKey",
  kind: MethodKind.Unary,
  I: GetAPIKeyRequest,
  O: APIKey,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.CreateAPIKey
 */
export const createAPIKey = {
  localName: "createAPIKey",
  name: "CreateAPIKey",
  kind: MethodKind.Unary,
  I: CreateAPIKeyRequest,
  O: APIKey,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.DeleteAPIKey
 */
export const deleteAPIKey = {
  localName: "deleteAPIKey",
  name: "DeleteAPIKey",
  kind: MethodKind.Unary,
  I: DeleteAPIKeyRequest,
  O: Empty,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.ListSAMLOAuthClients
 */
export const listSAMLOAuthClients = {
  localName: "listSAMLOAuthClients",
  name: "ListSAMLOAuthClients",
  kind: MethodKind.Unary,
  I: ListSAMLOAuthClientsRequest,
  O: ListSAMLOAuthClientsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.GetSAMLOAuthClient
 */
export const getSAMLOAuthClient = {
  localName: "getSAMLOAuthClient",
  name: "GetSAMLOAuthClient",
  kind: MethodKind.Unary,
  I: GetSAMLOAuthClientRequest,
  O: SAMLOAuthClient,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.CreateSAMLOAuthClient
 */
export const createSAMLOAuthClient = {
  localName: "createSAMLOAuthClient",
  name: "CreateSAMLOAuthClient",
  kind: MethodKind.Unary,
  I: CreateSAMLOAuthClientRequest,
  O: SAMLOAuthClient,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.DeleteSAMLOAuthClient
 */
export const deleteSAMLOAuthClient = {
  localName: "deleteSAMLOAuthClient",
  name: "DeleteSAMLOAuthClient",
  kind: MethodKind.Unary,
  I: DeleteSAMLOAuthClientRequest,
  O: Empty,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppListOrganizations
 */
export const appListOrganizations = {
  localName: "appListOrganizations",
  name: "AppListOrganizations",
  kind: MethodKind.Unary,
  I: AppListOrganizationsRequest,
  O: AppListOrganizationsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppGetOrganization
 */
export const appGetOrganization = {
  localName: "appGetOrganization",
  name: "AppGetOrganization",
  kind: MethodKind.Unary,
  I: AppGetOrganizationRequest,
  O: Organization,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppCreateOrganization
 */
export const appCreateOrganization = {
  localName: "appCreateOrganization",
  name: "AppCreateOrganization",
  kind: MethodKind.Unary,
  I: AppCreateOrganizationRequest,
  O: Organization,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppUpdateOrganization
 */
export const appUpdateOrganization = {
  localName: "appUpdateOrganization",
  name: "AppUpdateOrganization",
  kind: MethodKind.Unary,
  I: AppUpdateOrganizationRequest,
  O: Organization,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppGetAdminSettings
 */
export const appGetAdminSettings = {
  localName: "appGetAdminSettings",
  name: "AppGetAdminSettings",
  kind: MethodKind.Unary,
  I: AppGetAdminSettingsRequest,
  O: AppGetAdminSettingsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppUpdateAdminSettings
 */
export const appUpdateAdminSettings = {
  localName: "appUpdateAdminSettings",
  name: "AppUpdateAdminSettings",
  kind: MethodKind.Unary,
  I: AppUpdateAdminSettingsRequest,
  O: AppUpdateAdminSettingsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppUpdateAdminSettingsLogo
 */
export const appUpdateAdminSettingsLogo = {
  localName: "appUpdateAdminSettingsLogo",
  name: "AppUpdateAdminSettingsLogo",
  kind: MethodKind.Unary,
  I: AppUpdateAdminSettingsLogoRequest,
  O: AppUpdateAdminSettingsLogoResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppCreateAdminSetupURL
 */
export const appCreateAdminSetupURL = {
  localName: "appCreateAdminSetupURL",
  name: "AppCreateAdminSetupURL",
  kind: MethodKind.Unary,
  I: AppCreateAdminSetupURLRequest,
  O: AppCreateAdminSetupURLResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppListSAMLConnections
 */
export const appListSAMLConnections = {
  localName: "appListSAMLConnections",
  name: "AppListSAMLConnections",
  kind: MethodKind.Unary,
  I: AppListSAMLConnectionsRequest,
  O: AppListSAMLConnectionsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppGetSAMLConnection
 */
export const appGetSAMLConnection = {
  localName: "appGetSAMLConnection",
  name: "AppGetSAMLConnection",
  kind: MethodKind.Unary,
  I: AppGetSAMLConnectionRequest,
  O: SAMLConnection,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppCreateSAMLConnection
 */
export const appCreateSAMLConnection = {
  localName: "appCreateSAMLConnection",
  name: "AppCreateSAMLConnection",
  kind: MethodKind.Unary,
  I: AppCreateSAMLConnectionRequest,
  O: SAMLConnection,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppUpdateSAMLConnection
 */
export const appUpdateSAMLConnection = {
  localName: "appUpdateSAMLConnection",
  name: "AppUpdateSAMLConnection",
  kind: MethodKind.Unary,
  I: AppUpdateSAMLConnectionRequest,
  O: SAMLConnection,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppListSAMLFlows
 */
export const appListSAMLFlows = {
  localName: "appListSAMLFlows",
  name: "AppListSAMLFlows",
  kind: MethodKind.Unary,
  I: AppListSAMLFlowsRequest,
  O: AppListSAMLFlowsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppGetSAMLFlow
 */
export const appGetSAMLFlow = {
  localName: "appGetSAMLFlow",
  name: "AppGetSAMLFlow",
  kind: MethodKind.Unary,
  I: AppGetSAMLFlowRequest,
  O: SAMLFlow,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.ParseSAMLMetadata
 */
export const parseSAMLMetadata = {
  localName: "parseSAMLMetadata",
  name: "ParseSAMLMetadata",
  kind: MethodKind.Unary,
  I: ParseSAMLMetadataRequest,
  O: ParseSAMLMetadataResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppListSCIMDirectories
 */
export const appListSCIMDirectories = {
  localName: "appListSCIMDirectories",
  name: "AppListSCIMDirectories",
  kind: MethodKind.Unary,
  I: AppListSCIMDirectoriesRequest,
  O: AppListSCIMDirectoriesResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppGetSCIMDirectory
 */
export const appGetSCIMDirectory = {
  localName: "appGetSCIMDirectory",
  name: "AppGetSCIMDirectory",
  kind: MethodKind.Unary,
  I: AppGetSCIMDirectoryRequest,
  O: SCIMDirectory,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppCreateSCIMDirectory
 */
export const appCreateSCIMDirectory = {
  localName: "appCreateSCIMDirectory",
  name: "AppCreateSCIMDirectory",
  kind: MethodKind.Unary,
  I: AppCreateSCIMDirectoryRequest,
  O: SCIMDirectory,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppUpdateSCIMDirectory
 */
export const appUpdateSCIMDirectory = {
  localName: "appUpdateSCIMDirectory",
  name: "AppUpdateSCIMDirectory",
  kind: MethodKind.Unary,
  I: AppUpdateSCIMDirectoryRequest,
  O: SCIMDirectory,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppRotateSCIMDirectoryBearerToken
 */
export const appRotateSCIMDirectoryBearerToken = {
  localName: "appRotateSCIMDirectoryBearerToken",
  name: "AppRotateSCIMDirectoryBearerToken",
  kind: MethodKind.Unary,
  I: AppRotateSCIMDirectoryBearerTokenRequest,
  O: AppRotateSCIMDirectoryBearerTokenResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppListSCIMUsers
 */
export const appListSCIMUsers = {
  localName: "appListSCIMUsers",
  name: "AppListSCIMUsers",
  kind: MethodKind.Unary,
  I: AppListSCIMUsersRequest,
  O: AppListSCIMUsersResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppGetSCIMUser
 */
export const appGetSCIMUser = {
  localName: "appGetSCIMUser",
  name: "AppGetSCIMUser",
  kind: MethodKind.Unary,
  I: AppGetSCIMUserRequest,
  O: SCIMUser,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppListSCIMGroups
 */
export const appListSCIMGroups = {
  localName: "appListSCIMGroups",
  name: "AppListSCIMGroups",
  kind: MethodKind.Unary,
  I: AppListSCIMGroupsRequest,
  O: AppListSCIMGroupsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppGetSCIMGroup
 */
export const appGetSCIMGroup = {
  localName: "appGetSCIMGroup",
  name: "AppGetSCIMGroup",
  kind: MethodKind.Unary,
  I: AppGetSCIMGroupRequest,
  O: SCIMGroup,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppListSCIMRequests
 */
export const appListSCIMRequests = {
  localName: "appListSCIMRequests",
  name: "AppListSCIMRequests",
  kind: MethodKind.Unary,
  I: AppListSCIMRequestsRequest,
  O: AppListSCIMRequestsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AppGetSCIMRequest
 */
export const appGetSCIMRequest = {
  localName: "appGetSCIMRequest",
  name: "AppGetSCIMRequest",
  kind: MethodKind.Unary,
  I: AppGetSCIMRequestRequest,
  O: AppGetSCIMRequestResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AdminRedeemOneTimeToken
 */
export const adminRedeemOneTimeToken = {
  localName: "adminRedeemOneTimeToken",
  name: "AdminRedeemOneTimeToken",
  kind: MethodKind.Unary,
  I: AdminRedeemOneTimeTokenRequest,
  O: AdminRedeemOneTimeTokenResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AdminWhoami
 */
export const adminWhoami = {
  localName: "adminWhoami",
  name: "AdminWhoami",
  kind: MethodKind.Unary,
  I: AdminWhoamiRequest,
  O: AdminWhoamiResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AdminListSAMLConnections
 */
export const adminListSAMLConnections = {
  localName: "adminListSAMLConnections",
  name: "AdminListSAMLConnections",
  kind: MethodKind.Unary,
  I: AdminListSAMLConnectionsRequest,
  O: AdminListSAMLConnectionsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AdminGetSAMLConnection
 */
export const adminGetSAMLConnection = {
  localName: "adminGetSAMLConnection",
  name: "AdminGetSAMLConnection",
  kind: MethodKind.Unary,
  I: AdminGetSAMLConnectionRequest,
  O: AdminGetSAMLConnectionResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AdminCreateSAMLConnection
 */
export const adminCreateSAMLConnection = {
  localName: "adminCreateSAMLConnection",
  name: "AdminCreateSAMLConnection",
  kind: MethodKind.Unary,
  I: AdminCreateSAMLConnectionRequest,
  O: AdminCreateSAMLConnectionResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AdminUpdateSAMLConnection
 */
export const adminUpdateSAMLConnection = {
  localName: "adminUpdateSAMLConnection",
  name: "AdminUpdateSAMLConnection",
  kind: MethodKind.Unary,
  I: AdminUpdateSAMLConnectionRequest,
  O: AdminUpdateSAMLConnectionResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AdminParseSAMLMetadata
 */
export const adminParseSAMLMetadata = {
  localName: "adminParseSAMLMetadata",
  name: "AdminParseSAMLMetadata",
  kind: MethodKind.Unary,
  I: AdminParseSAMLMetadataRequest,
  O: AdminParseSAMLMetadataResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AdminListSAMLFlows
 */
export const adminListSAMLFlows = {
  localName: "adminListSAMLFlows",
  name: "AdminListSAMLFlows",
  kind: MethodKind.Unary,
  I: AdminListSAMLFlowsRequest,
  O: AdminListSAMLFlowsResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AdminGetSAMLFlow
 */
export const adminGetSAMLFlow = {
  localName: "adminGetSAMLFlow",
  name: "AdminGetSAMLFlow",
  kind: MethodKind.Unary,
  I: AdminGetSAMLFlowRequest,
  O: AdminGetSAMLFlowResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AdminListSCIMDirectories
 */
export const adminListSCIMDirectories = {
  localName: "adminListSCIMDirectories",
  name: "AdminListSCIMDirectories",
  kind: MethodKind.Unary,
  I: AdminListSCIMDirectoriesRequest,
  O: AdminListSCIMDirectoriesResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AdminGetSCIMDirectory
 */
export const adminGetSCIMDirectory = {
  localName: "adminGetSCIMDirectory",
  name: "AdminGetSCIMDirectory",
  kind: MethodKind.Unary,
  I: AdminGetSCIMDirectoryRequest,
  O: AdminGetSCIMDirectoryResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AdminCreateSCIMDirectory
 */
export const adminCreateSCIMDirectory = {
  localName: "adminCreateSCIMDirectory",
  name: "AdminCreateSCIMDirectory",
  kind: MethodKind.Unary,
  I: AdminCreateSCIMDirectoryRequest,
  O: AdminCreateSCIMDirectoryResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AdminUpdateSCIMDirectory
 */
export const adminUpdateSCIMDirectory = {
  localName: "adminUpdateSCIMDirectory",
  name: "AdminUpdateSCIMDirectory",
  kind: MethodKind.Unary,
  I: AdminUpdateSCIMDirectoryRequest,
  O: AdminUpdateSCIMDirectoryResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;

/**
 * @generated from rpc ssoready.v1.SSOReadyService.AdminRotateSCIMDirectoryBearerToken
 */
export const adminRotateSCIMDirectoryBearerToken = {
  localName: "adminRotateSCIMDirectoryBearerToken",
  name: "AdminRotateSCIMDirectoryBearerToken",
  kind: MethodKind.Unary,
  I: AdminRotateSCIMDirectoryBearerTokenRequest,
  O: AdminRotateSCIMDirectoryBearerTokenResponse,
  service: {
    typeName: "ssoready.v1.SSOReadyService"
  }
} as const;
